import { render, staticRenderFns } from "./InterstitialMaterialWriteXa.vue?vue&type=template&id=53ec8a0d&scoped=true"
import script from "./InterstitialMaterialWriteXa.vue?vue&type=script&lang=js"
export * from "./InterstitialMaterialWriteXa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec8a0d",
  null
  
)

export default component.exports